const COGNITO_DOMAIN = 'https://orioles-lottery-dev-224806504469.auth.us-east-1.amazoncognito.com';
const CLIENT_ID = 'v1sk7o5rmqlodhthoe6sccp17';
const REDIRECT_URI = 'https://ballpark.synergyecp.com';
const ADMIN_GROUP_ID = 'cc0c4065-dc4d-48bf-bf84-0ce13bade866';

export function login() {
  const state = crypto.randomUUID();
  sessionStorage.setItem('oauth_state', state);
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: CLIENT_ID,
    redirect_uri: REDIRECT_URI,
    scope: 'openid profile email',
    state,
    identity_provider: 'EntraID',
  });
  window.location.href = `${COGNITO_DOMAIN}/oauth2/authorize?${params}`;
}

export async function handleCallback() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');
  if (!code) return false;
  if (state !== sessionStorage.getItem('oauth_state')) {
    console.error('OAuth state mismatch');
    return false;
  }
  const res = await fetch(`${COGNITO_DOMAIN}/oauth2/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: CLIENT_ID,
      redirect_uri: REDIRECT_URI,
      code,
    }),
  });
  if (!res.ok) return false;
  const tokens = await res.json();
  sessionStorage.setItem('id_token', tokens.id_token);
  sessionStorage.setItem('access_token', tokens.access_token);
  window.history.replaceState({}, '', '/');
  return true;
}

export function getToken() {
  return sessionStorage.getItem('id_token');
}

export function logout() {
  sessionStorage.removeItem('id_token');
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('oauth_state');
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    logout_uri: REDIRECT_URI,
  });
  window.location.href = `${COGNITO_DOMAIN}/logout?${params}`;
}

function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

export function getUser() {
  const token = getToken();
  if (!token) return null;
  const claims = parseJwt(token);
  if (!claims) return null;
  const groups = claims['custom:groups'] || '';
  const isAdmin = groups.includes(ADMIN_GROUP_ID);
  return {
    name: claims.name || claims.email || '',
    isAdmin,
  };
}

export function isAuthenticated() {
  const token = getToken();
  if (!token) return false;
  const claims = parseJwt(token);
  if (!claims) return false;
  return claims.exp > Date.now() / 1000;
}
